import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import React from 'react';
import { StructureService } from '../../../../services/structure_service';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function getVsmeBasisEntities(data?: any) {
    const b1: any = ((data || {})[IDs.ENT_VSME_B1] || [])[0] || {};
    const group = 'vsme_basis';
    const infoTextStyle = { maxWidth: 600 };
    const includePatModul = Object.keys(b1).length ? (b1.modul === 'basis_pat' || b1.modul === 'basis_pat_geschaeft') : true;
    return [
        { gliederung: '1.', gliederung2: 'I.', collapsible: group, name: 'Allgemein', infoTextKey: 'hinweis_vsme_allgemein' },
        { gliederung: '2.', gliederung2: 'II.', collapsible: group, name: 'Umwelt', infoTextKey: 'hinweis_vsme_umwelt' },
        { gliederung: '3.', gliederung2: 'III.', collapsible: group, name: 'Soziales', infoTextKey: 'hinweis_vsme_soziales' },
        { gliederung: '4.', gliederung2: 'IV.', collapsible: group, name: 'Governance', infoTextKey: 'hinweis_vsme_governance' }
      
    ];
}

export function getAssistentConfigVsmeBasisItems(data: any, triggerService: TriggerService, structureService: StructureService): AssistentItem[] {
    const ents = getVsmeBasisEntities(data);
    const items: AssistentItem[] = ents.filter((e: any) => !e.disabled).map((e: any) => {
        if (e.collapsible && !e.key) {
            return {
                collapsible: e.collapsible,
                group: e.group,
                gliederung: e.gliederung,
                gliederung2: e.gliederung2,
                name: e.name,
                style: { backgroundColor: e.colBg || '#616468', color: !e.colBg && 'white' },
                type: 'CustomGroupElement',
                infoTextKey: e.infoTextKey
            };
        }
        const structure = structureService.getStructureByKey(IDs.MOD_ETOOL, e.key) || {};
        return {
            collapsible: e.collapsible,
            group: e.group,
            gliederung: e.gliederung,
            gliederung2: e.gliederung2,
            name: e.name || structure.TITEL,
            colBg: e.colBg,
            dataName: structure.TITEL,
            description: 'Dies ist das Formular zur Eingabe der VSME-Daten.',
            type: e.type || 'EntityForm',
            addLabel: 'Neuen Datensatz erfassen',
            entity: e.key,
            configFlag: 'inputVsmeBasis',
            singleItem: e.singleItem,
            customOnSaveDone: (ent: string, dataItem: any) => {
                triggerService.fire('reload', ent);
            },
            infoTextKey: e.infoTextKey,
            infoTextStyle: e.infoTextStyle,
            disableIndicator: e.disableIndicator,
            extraFormElementAfter: e.extraFormElementAfter
        }
    });
    return items;
}
